import React from 'react';

function CategorySidebar({
  categories,
  selectedCategory,
  onCategorySelect,
  isActive,
  toggleSidebar,
}) {
  return (
    <article
      className={`subProductCategory col-lg-4 col-xl-3 bg-white br_10 ${
        isActive ? 'active' : ''
      }`}
    >
      <div className=" p-3 br_10 ">
        <div className="d-flex justify-content-between align-items-center">
          <h3 className="font_18 font_600">All Categories</h3>
          <i
            onClick={toggleSidebar}
            class="fa-solid fa-angle-left font_16 w_35x h_35x d-flex d-lg-none justify-content-center align-items-center rounded-circle bg_gray"
          ></i>
        </div>
        <div className="mt-3">
          {categories.map((category, index) => {
            const categoryName = category.category;
            const isSelectedCategory = selectedCategory === categoryName;
            return (
              <div
                key={index}
                className={`d-flex justify-content-between mb-2 mx-1 cursor-pointer ${
                  isSelectedCategory ? 'active-category' : ''
                } border-bottom pb-2 align-items-center`}
                onClick={() => onCategorySelect(categoryName)}
              >
                <div className="d-flex align-items-center gap-2 my-2 ">
                  <div className="font_13 font_600 icon_bg h_30x d-flex justify-content-center align-items-center text-black-50 rounded-circle bg_gray5 w_35x br_10">
                    <i
                      className={`fa-solid fa-layer-group ${
                        isSelectedCategory ? 'text_master2' : 'text_gray10'
                      }`}
                    ></i>
                  </div>

                  <div
                    className={`font_14 font_500 ${
                      isSelectedCategory ? '' : 'text_gray10'
                    }`}
                  >
                    {categoryName}
                  </div>
                </div>
                <div className="font_13 font_600  h_27x d-flex justify-content-center align-items-center text-black-50 rounded-circle w_40x br_15 bg_gray5">
                  {category.itemsCount}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </article>
  );
}

export default CategorySidebar;
